import React from 'react';
import { Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LoginMenu, useAuth } from '../../auth';
import LanguageToggle from './LanguageToggle';
import './header.css';

/**
 * Main application header component
 * Displays navigation menu based on user roles and authentication state
 */
const Header: React.FC = () => {
  const { t } = useTranslation();
  const { roles: userRoles } = useAuth();

  return (
    <div className="header">
      <AppBar
        position="relative"
        elevation={4}
        sx={{
          boxShadow:
            '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
        }}
      >
        <Toolbar>
          {/* Home/Brand Link */}
          <Link to="/">
            <Typography style={{ fontSize: '1.1rem' }} variant="h4">
              {t('bvger_forums')}
            </Typography>
          </Link>

          {/* Forums Link - Available to all authenticated users (Teilnehmer, Organisator, Admin) */}
          {userRoles.some(ur =>
            ['Teilnehmer', 'Organisator', 'Admin'].includes(ur)
          ) && (
            <Link to="/foren">
              <Typography style={{ fontSize: '1rem' }} variant="h5">
                {t('forums')}
              </Typography>
            </Link>
          )}

          {/* Create Forum Link - Available to Organisator and Admin */}
          {userRoles.some(ur => ['Organisator', 'Admin'].includes(ur)) && (
            <Link to="/foren/erstellen">
              <Typography style={{ fontSize: '1rem' }} variant="h5">
                {t('create_forum')}
              </Typography>
            </Link>
          )}

          {/* Manage Forums Link - Available to Organisator and Admin */}
          {userRoles.some(ur => ['Organisator', 'Admin'].includes(ur)) && (
            <Link to="/foren/verwalten">
              <Typography style={{ fontSize: '1rem' }} variant="h5">
                {t('manage_forums')}
              </Typography>
            </Link>
          )}

          {/* Admin Console Link - Available to Admin only */}
          {userRoles.some(ur => ['Admin'].includes(ur)) && (
            <Link to="/foren/adminkonsole">
              <Typography style={{ fontSize: '1rem' }} variant="h5">
                {t('admin_console')}
              </Typography>
            </Link>
          )}

          {/* Right side navigation - Language toggle and login/logout */}
          <div className="navigation-right">
            <LanguageToggle />
            <LoginMenu />
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Header;
